<template>
  <canvas ref="myChart" id="myChart" width="250px"></canvas>
</template>

<script>
import * as Colors from './color'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    total: {
      get() {
        return this.$store.state.statistics.stat.data.total
      }
    },
    others: {
      get() {
        // console.log(this.data)
        let total = 0
        if (this.data) {
          Object.keys(this.data).forEach((key,index) => {
            total += this.data[key]
          });

          total = this.total - total
        }

        return total
      }
    }
  },
  watch: {
    data(n, o) {
      if (n) {
        this.updateData()
      }
    }
  },
  methods: {
    updateData() {
      if (this.$chrt) {
          this.$chrt.data.labels = []
          this.$chrt.data.datasets[0].data = []
          Object.keys(this.data).forEach((key,index) => {
            this.$chrt.data.labels.push(key.replace('Years', 'yr').replace('Old', 'old'))

            this.$chrt.data.datasets.forEach((dataset) => {
              dataset.data.push(Math.ceil((this.data[key] / this.total) * 100))
            });
          });

          if(this.others) {
            // Due to missing data, we will fix this to make are chart as true as possible
            // this.$chrt.data.labels.push('Did not specify')
            // this.$chrt.data.datasets[0].data.push(this.others)
          }

          this.$chrt.update()
        }
    }
  },
  mounted() {
    this.$chrt = new Chart(this.$refs.myChart, {
      type: 'doughnut',
      data: {
        labels: [ ],
        datasets: [{
          label: 'Age Bracket',
          data: [ ],
          backgroundColor: Colors.arrayOfColorsAsString(['red', 'modifiedYellow', 'blue', 'green', 'purple', 'orange', 'grey'], 0.4) ,
          borderColor:  Colors.arrayOfColorsAsString(['red', 'modifiedYellow', 'blue', 'green', 'purple', 'orange', 'grey']),
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        legend: {
          display: true,
          position: 'left',
          labels: {
            boxWidth: 12,
          }
        },
        tooltips: {
            enabled: true,
            mode: 'single',
            callbacks: {
                label: function(tooltipItems, data) {
                  let label = data.labels[tooltipItems.index]
                  let value = data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index]
                  return `${label}: ${value}%`;
                }
            }
        },

      }
    })

    if (this.data) {
      this.$chrt.reset()
      this.updateData()
    }
  }
}
</script>
